import * as React from 'react'

import { useI18n, useSiteConfig, useTheme } from '@thg-commerce/enterprise-core'
import { Modal } from '@thg-commerce/gravity-elements'
import { ImageGallery } from '@thg-commerce/gravity-patterns'
import { Position } from '@thg-commerce/gravity-patterns/ImageGallery/types'
import { Direction, spacing } from '@thg-commerce/gravity-theme'

import { useProductPage } from '../../context'

export const ProductImageGalleryZoomPresenter = () => {
  const productPageContext = useProductPage()
  const {
    icons: { zoomIn, zoomOut },
  } = useTheme()
  const theme = useTheme()
  const i18n = useI18n()
  const { enablePDPGalleryZoom, videoThumbnailAsSVG } = useSiteConfig()
  const [open, setOpen] = React.useState(false)
  const [indexedImage, setIndexedImage] = React.useState(0)

  if (
    !productPageContext.product ||
    !productPageContext.presentImageGalleryZoomModal
  ) {
    return null
  }

  productPageContext.presentImageGalleryZoomModal.current = (
    indexImage: number,
  ) => {
    setIndexedImage(indexImage)
    setOpen(true)
  }
  return (
    <Modal
      contentPadding={'0'}
      hideOverflowX={true}
      gridColSpan={[12, 12, 10, 10]}
      gridRowSpan={[12, 10, 10, 10]}
      isFullHeightDesktop={true}
      i18nText={{
        closeAriaLabel: i18n('general.modal.close.button.arialabel'),
      }}
      open={open}
      onClose={() => {
        setOpen(false)
      }}
    >
      <ImageGallery
        urls={
          productPageContext.selectedVariant?.gallery ||
          productPageContext.product?.gallery || {
            thumbnails: [],
            images: [],
            zoom: [],
          }
        }
        controlIcons={{
          zoomIn: zoomIn?.svgPath,
          zoomOut: zoomOut?.svgPath,
          fill: theme.colors.palette.greys.dark,
        }}
        i18nText={{
          announcerI18nText: {
            imageChangeAnnouncerText: i18n(
              'imagegallery.announcer.imagechange.text',
            ),
            zoomLevelAnnouncerText: i18n(
              'imagegallery.announcer.zoomlevel.text',
            ),
            fullscreenEnterAnnouncerText: i18n(
              'imagegallery.announcer.fullscreenview.enter.text',
            ),
            fullscreenExitAnnouncerText: i18n(
              'imagegallery.announcer.fullscreenview.exit.text',
            ),
            panI18nText: {
              imagePanAnnouncerText: i18n(
                'imagegallery.announcer.panning.text',
              ),
              leftText: i18n('imagegallery.announcer.pan.direction.left.text'),
              rightText: i18n(
                'imagegallery.announcer.pan.direction.right.text',
              ),
              downText: i18n('imagegallery.announcer.pan.direction.down.text'),
              upText: i18n('imagegallery.announcer.pan.direction.up.text'),
            },
          },
          accessibilityLabel: i18n('imagegallery.accessibilitylabel.text'),
        }}
        altText={productPageContext.product?.title || ''}
        direction={[Direction.COLUMN, Direction.ROW]}
        thumbnailSize={[78]}
        controlSize={[48]}
        zoomControlPosition={[Position.BOTTOM_RIGHT]}
        zoomBackgroundColor={
          theme.patterns.imageGallery.carouselControls?.zoomBackgroundColor
        }
        zoomControl={true}
        zoomEnabled={enablePDPGalleryZoom}
        fullscreenControlPosition={[Position.TOP_RIGHT]}
        gapSpacing={[2]}
        thumbnailPadding={{
          xs: `0 0 0 ${spacing(1)}`,
          sm: `${spacing(2)} 0 0 ${spacing(2)}`,
        }}
        presentImageGalleryZoomModal={true}
        selectedImageIndex={indexedImage}
        carousel={{
          itemGapSpacing: 1,
        }}
        videoThumbnailAsSVG={videoThumbnailAsSVG}
      />
    </Modal>
  )
}
